<template>
    <transition name="fade">

        <div class="vue-modal"  v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner">
                    <div class="vue-modal-content shadow-lg" style="background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <slot />
                        <label class="h4 fw-bold" style="font-weight:bold; text-align: center; color: #ff6b6b; display: block; margin-bottom: 15px;" id="ERROR"> </label>
                                             
                        <div class="container-fluid">
                            <div class="form-group mb-3">
                                <label title="Old Password" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Old Password</label>
                                <input type="password" name="OldPassword" class="form-control input-lg" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" @focus="clearErrorMsg" id="oldPassword" v-model="oldPassword"/>
                            </div>

                            <div class="form-group mb-3">
                                <label title="New Password" style="font-size: 1.2em; display: block; margin-bottom: 5px;">New Password</label>
                                <input type="password" name="NewPassword" class="form-control input-lg" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" @focus="clearErrorMsg" id="NewPassword" v-model="newPassword"/>
                            </div>

                            <div class="form-group mb-3">
                                <label title="Confirm Password" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Confirm Password</label>
                                <input type="password" name="ConfirmPassword" class="form-control input-lg" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);" @focus="clearErrorMsg" id="ConfirmPassword" v-model="confirmPassword"/>
                            </div>

                            <div style="text-align: right; margin-top: 20px; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 20px;">
                                <button @click="close()" class="btn btn-danger btn-lg" style="font-size: 1.2em; margin-right: 10px;">Cancel</button>
                                <button @click="Login()" class="btn btn-success btn-lg" style="font-size: 1.2em;">Change password</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>

import axios from "axios";
import commonServices from "@/shared/commonServices"
export default {
    mixins: [commonServices],
    name:"Login",
    data: function(){
        return {
            oldPassword : '',
            newPassword : '',
            confirmPassword : '',
        }
    },
    methods:{
        clearErrorMsg(){
            document.getElementById("ConfirmPassword").style.borderWidth ='1px'; 
            document.getElementById("ConfirmPassword").style.borderColor ='black'; 
            document.getElementById("ERROR").textContent =''; 
        },
        
        changePassword: async function(){
            try{
                let dataURL = this.apiURL+'Login/changePassword';
                let loginJson = {'oldPassword': this.oldPassword, 'username': localStorage.username, "newPassword" : this.newPassword};
                let response = await axios.post(dataURL, loginJson); 
                if(response.data.status === 'success'){
                    this.showAlert("Password Updated Successfully");
                }
            }
            catch (error){
                console.log(error);
        }
    },

        Login: async function(){
            if(this.newPassword === this.confirmPassword){
                try{
                let dataURL = this.apiURL+'Login';
                let loginJson = {'action': 'login', 'username': localStorage.username, "password" : this.oldPassword};
                let response = await axios.post(dataURL, loginJson); 
                if(response.data.status === 'success'){
                    this.changePassword();
                }else{
                    this.showAlert("User name or old password is not correct");
                }
            }
            catch (error){
                console.log(error);
            }
            this.close();
            }else{
                document.getElementById("ConfirmPassword").style.borderWidth ='3px'; 
                document.getElementById("ConfirmPassword").style.borderColor ='red'; 
                document.getElementById("ERROR").textContent ='New password and confirmation did not match'; 
                
            }
        }
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
    /*
    created(){
            console.log("event.keyCode")
        const handleKeyUp = (event) => {
            console.log("event.keyCode", event.keyCode)
            if(event.keyCode === 27) {
                close();

            }
        };
        onMounted(() => document.addEventListener("keyup", handleKeyUp));
        onUnmounted(() => document.removeEventListener("keyup", handleKeyUp));

    }
    */
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 100;
}
.vue-modal-inner {
    max-width: 500px;
    margin: 2rem auto;
}
.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 2rem;
    padding: 1rem;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
</style>
